import React from "react";
import "./ChangeScenarioButton.css";

function ChangeScenarioButton({ toggleScenario }) {
  const handleMouseDown = (event) => {
    event.stopPropagation();
  };
  
  return (
    <button className="change-scenario-button" onClick={toggleScenario} onMouseDown={handleMouseDown}>
      Change Scenario
    </button>
  );
}

export default ChangeScenarioButton;
